
<div *ngIf="outcome">
  <div class="addUserHeading mx-2-5 mt-2 pb-1rem">
    <span *ngIf="userData == null">{{addUserLabel}}</span>
    <span *ngIf="userData != null">{{updateUserLabel}}</span>
  </div>
  <div class="mx-2-5 mb-3-5">
    <div [formGroup]="userForm">
      <div>
        <mat-form-field class="width-100">
          <mat-label class="textBox-text">{{firstnameLabel}}</mat-label>
          <input appAutoFocus class="textBox-text" matInput placeholder="" formControlName="firstname" type="text" maxlength="100" />
        </mat-form-field>
        <div *ngIf="!isFirstNameContentValid" class="red  mt-1">{{firstnameError}}</div>
      </div>
      <div>
        <mat-form-field class="width-100">
          <mat-label class="textBox-text">{{lastnameLabel}}</mat-label>
          <input class="textBox-text" matInput placeholder="" formControlName="lastname" type="text" maxlength="100">
        </mat-form-field>
        <div *ngIf="!isLastNameContentValid" class="red mt-1">{{lastnameError}}</div>
      </div>
      <div>
        <mat-form-field class="width-100">
          <mat-label class="textBox-text">{{emailLabelForm}}</mat-label>
          <input class="textBox-text" matInput placeholder="" formControlName="email" type="text" maxlength="100" />
        </mat-form-field>
        <div *ngIf="!emailValid" class="red mt-1">{{emailError}}</div>
      </div>
      <div>
        <mat-form-field class="width-100">
          <mat-label class="textBox-text">{{passwordlabel}}</mat-label>
          <input class="textBox-text" matInput placeholder="" formControlName="password" type="password" maxlength="30" />
        </mat-form-field>
        <div *ngIf="!isPasswordContentValid" class="red mt-1">{{passwordError}}</div>
      </div>

      <div class="mt-2 width-100" *ngIf="!isHomePage">
        <mat-checkbox formControlName="admin" color="primary">{{isUserAdminLabel}}</mat-checkbox>
      </div>

      <div class="flex-display mt-2 pt-1">
        <button mat-button class="btn-secondary-action-close" (click)="closeOverlayButton()" (keyup.enter)="closeOverlayButton()" tabindex="0">Cancel</button>
        <button mat-button class="btn-primary-action-add" (click)="addUser()" (keyup.enter)="addUser()" tabindex="0">
          <span *ngIf="userData == null">{{addbuttonLabel}}</span>
          <span *ngIf="userData != null">{{updateButtonLabel}}</span>
        </button>
      </div>
    </div>
  </div>
</div>
